import React from 'react';

import Modal from "../../component/modal/ModalTemplate";
import PaginationComponent from "../../component/table/Pagination";

class AppRequestListModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

        }
    }

    render() {
        const { isOpen, onRequestClose } = this.props;
        const { page, size, total, list, handlePageChange } = this.props;

        return (
            <Modal
                open={isOpen}
                handleClose={onRequestClose}
                modalTitle="웹/앱 등록 요청 목록"
                className="react-full-modal"
            >
                <div className='modal-body' style={{maxHeight: '500px', overflowY: 'auto'}}>
                    <div className="row py-2">
                        <div className="col-lg-6">총 {total} 건</div>
                    </div>
                    <div className='table-responsive'>
                        <table className="table table-bordered table-hover fs-6">
                            <thead className="table-light">
                            <tr>
                                <th>번호</th>
                                <th>요청일시</th>
                                <th>요청 웹/앱</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                total === 0 &&
                                <tr>
                                    <td colSpan="3" className="text-center">웹/앱 등록 요청 내역이 없습니다.</td>
                                </tr>
                            }
                            {
                                list.map((item, idx) => (
                                    <tr key={idx}>
                                        <td className="text-center">{idx + 1}</td>
                                        <td className="">{item.name}</td>
                                        <td className="">
                                            {
                                                item.webappList.map((webapp, i) => {
                                                    return <p key={i} className="mb-0">{webapp.name} ({webapp.value})</p>
                                                })
                                            }
                                        </td>
                                    </tr>
                                ))
                            }
                            </tbody>
                        </table>
                    </div>
                    <PaginationComponent page={page} total={total} sizePerPage={size} handleChange={handlePageChange}/>
                </div>
                <div className='modal-footer justify-content-center'>
                    <button className='btn btn-md btn-secondary' onClick={onRequestClose}>닫기</button>
                </div>
            </Modal>
        )
    }
}

export default AppRequestListModal;
